/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Description from './Description/index'
import EmailAddress from './EmailAddress/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Email/Fields"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Fields.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-2tX3iC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<EmailAddress
  viewPath={`${viewPath}/EmailAddress`}
/>
</div>
<div
  data-testid="Fields.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-2tX3iC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
</div>
{children}
</React.Fragment>)
}